<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Galileo Computing VueJS Dashboard
  Author: Ian Kibet
  Author URL: http://ian.galileoc.co.ke
========================================================================================== -->

<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>
        {{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }}
        FARM
      </h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">
        <vs-input
          label="Name"
          v-model="name"
          class="mt-5 w-full"
          name="name"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('name')">{{
          errors.first("name")
        }}</span>

        <vs-input
          label="Location"
          v-model="location"
          class="mt-5 w-full"
          name="location"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('location')">{{
          errors.first("location")
        }}</span>

        <br />
        <span class="mt-5 ml-1 text-sm">Ownership</span>
        <v-select
          class="inputx w-full"
          v-model="os"
          name="ownership"
          :options="ownership"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('ownership')">{{
          errors.first("ownership")
        }}</span>

        <vs-input
          :label="`${os ? `${os} ` : ''}Price`"
          v-model="price"
          class="mt-5 w-full"
          :name="`price`"
          v-validate="'required|numeric'"
        />
        <span class="text-danger text-sm" v-show="errors.has(`price`)">{{
          errors.first(`price`)
        }}</span>

        <vs-input
          label="Estimated m3"
          v-model="m3"
          class="mt-5 w-full"
          name="m3"
          v-validate="'required|numeric'"
        />
        <span class="text-danger text-sm" v-show="errors.has('m3')">{{
          errors.first("m3")
        }}</span>
        <vs-input
          label="Acreage"
          v-model="acre"
          class="mt-5 w-full"
          name="acre"
          v-validate="'required|numeric'"
        />
        <span class="text-danger text-sm" v-show="errors.has('acre')">{{
          errors.first("acre")
        }}</span>

        <vs-textarea
          label="Description"
          v-model="description"
          class="mt-5 w-full"
        />
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid"
        >Submit</vs-button
      >
      <vs-button
        type="border"
        color="danger"
        @click="isSidebarActiveLocal = false"
        >Cancel</vs-button
      >
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
      if (Object.entries(this.data).length === 0) {
        this.initValues();
        this.$validator.reset();
      } else {
        let { _id, _rev, a, b, c, d, e, f, h } = JSON.parse(
          JSON.stringify(this.data)
        );
        this.id = _id;
        this.rev = _rev;
        this.name = a;
        this.location = b;
        this.price = c;
        this.os = d;
        this.m3 = e;
        this.acre = f;
        this.description = h;
        this.initValues();
      }
    },
  },
  data() {
    return {
      id: null,
      rev: null,
      name: "",
      location: "",
      price: "",
      os: "",
      m3: "",
      acre: "",
      description: "",
      ownership: ["Plantation", "Cubic"],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
    isFormValid() {
      return (
        !this.errors.any() &&
        this.name &&
        this.location &&
        this.os &&
        this.price &&
        this.m3 &&
        this.acre
      );
    },
  },
  methods: {
    initValues() {
      if (this.data._id) return;
      this.id = null;
      this.name = "";
      this.location = "";
      this.os = "";
      this.price = "";
      this.m3 = "";
      this.acre = "";
      this.description = "";
    },
    submitData() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.notify({
            color: "warning",
            title: "Processing",
            text: "Processing Data",
          });
          const obj = {
            _id: this.id,
            _rev: this.rev,
            a: this.name.toUpperCase(),
            b: this.location.toUpperCase(),
            c: this.price,
            d: this.os,
            e: this.m3,
            f: this.acre,
            g: Date.now(),
            h: this.description,
            i: [],
            y: Date.now(),
            z: 6,
          };

          if (this.id !== null && this.rev !== null) {
            this.$store
              .dispatch("farms/updateFarm", obj)
              .then((r) => {
                this.$vs.notify({
                  color: "success",
                  title: "Success",
                  text: r,
                });
                this.$emit("closeSidebar");
                this.initValues();
              })
              .catch((err) => {
                console.error(err);
                this.$vs.notify({
                  color: "danger",
                  title: "Error",
                  text: err,
                });
              });
          } else {
            delete obj._id;
            delete obj._rev;
            this.$store
              .dispatch("farms/addFarm", obj)
              .then((r) => {
                this.$vs.notify({
                  color: "success",
                  title: "Success",
                  text: r,
                });
                this.$emit("closeSidebar");
                this.initValues();
              })
              .catch((err) => {
                console.error(err);
                this.$vs.notify({
                  color: "danger",
                  title: "Error",
                  text: err,
                });
              });
          }
        }
      });
    },
  },
  components: {
    VuePerfectScrollbar,
    "v-select": vSelect,
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
